import { reloadAccessControl } from './accessControlStore';
import { isCentralDbEnabled } from './centralDb/config';

/** Paid/blocked — semua browser publik ambil dari server terpusat. */
const REFRESH_MS_CENTRAL = 30_000;
const REFRESH_MS_LOCAL = 90_000;

let intervalId: number | undefined;

export function initPaidAccessSync() {
  if (typeof window === 'undefined') return;

  const refresh = () => {
    void reloadAccessControl();
  };

  window.addEventListener('focus', refresh);
  window.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') refresh();
  });

  if (intervalId) window.clearInterval(intervalId);
  intervalId = window.setInterval(
    refresh,
    isCentralDbEnabled() ? REFRESH_MS_CENTRAL : REFRESH_MS_LOCAL,
  );

  if (isCentralDbEnabled()) {
    void reloadAccessControl();
  }
}
